import { Row, Col } from 'reactstrap';
import CertificateCard from './CertificateCard';
import { useTranslation } from 'react-i18next';
import dummyCertificateImage from '../resources/dummy_certificate.jpg';

import '../styles/CertificateCardGrid.css';

const CertificateCardGrid = ({ certificates = [] }) => {
    const { t } = useTranslation();

    const renderCards = (items) => (
        <Row className="certificate-card-grid">
            {items.map((certificate) => (
                <Col key={certificate.title} xs="12" md="6" xl="4">
                    <CertificateCard
                        title={t(certificate.title)}
                        image={dummyCertificateImage}
                        numberOfCertificates={certificate.numberOfCertificates}
                    />
                </Col>
            ))}
        </Row>
    );

    return (
        <div className="certificate-card-grid-container">
            {certificates.map(({ year, items, cumulativeItems = [] }) => (
                <section className="certificate-year-section" key={year}>
                    <h2 className="certificate-year-title">{year}</h2>
                    <h3 className="certificate-year-title">
                        {t('certificates_year_title', { year })}
                    </h3>
                    {renderCards(items)}
                    {cumulativeItems.length > 0 && (
                        <div className="certificate-cumulative-section">
                            <h3 className="certificate-year-title">
                                {t('certificates_cumulative_title', { year })}
                            </h3>
                            {renderCards(cumulativeItems)}
                        </div>
                    )}
                </section>
            ))}
        </div>
    );
};

export default CertificateCardGrid;
